import React from 'react';
import { fmtDec } from '../utils';

const REP_COLORS = ['#3ea4b1','#7F77DD','#1D9E75','#D4537E','#EF9F27','#888780','#5DCAA5','#F0997B'];
const RANK_CLASS = ['gold','silver','bronze'];

function initials(name) { return name.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase(); }

export default function Leaderboard({ data }) {
  const sorted = [...(data.owners || [])].sort((a, b) => b.total - a.total);
  const totalRev = sorted.reduce((s, r) => s + r.total, 0);
  const maxRev = sorted[0]?.total || 1;

  return (
    <div>
      <div className="section-head" style={{ marginBottom: 16 }}>Rep performance — 2026 YTD</div>
      <div className="leaderboard">
        {sorted.map((rep, i) => {
          const pct = Math.round(rep.total / maxRev * 100);
          const share = Math.round(rep.total / totalRev * 100);
          const color = REP_COLORS[i % REP_COLORS.length];
          return (
            <div className="lb-row" key={rep.name}>
              <span className={`lb-rank ${i < 3 ? RANK_CLASS[i] : ''}`}>{i + 1}</span>
              <div className="lb-avatar" style={{ background: color + '22', color }}>{initials(rep.name)}</div>
              <div className="lb-info">
                <div className="lb-name">{rep.name}</div>
                <div className="lb-role">Sales Rep · {share}% of total</div>
              </div>
              <div className="lb-bar-wrap">
                <div className="lb-track"><div className="lb-fill" style={{ width: pct + '%', background: color }} /></div>
                <div className="lb-pct">{pct}% of #1</div>
              </div>
              <div className="lb-total">{fmtDec(rep.total)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
